import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.css'],
    standalone: false
})
export class PageComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
